/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropvalidationprizenamerequired4Inputs */

const en_dropvalidationprizenamerequired4 = /** @type {(inputs: Dropvalidationprizenamerequired4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prize name is required`)
};

const de_dropvalidationprizenamerequired4 = /** @type {(inputs: Dropvalidationprizenamerequired4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preisname ist erforderlich`)
};

/**
* | output |
* | --- |
* | "Prize name is required" |
*
* @param {Dropvalidationprizenamerequired4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropvalidationprizenamerequired4 = /** @type {((inputs?: Dropvalidationprizenamerequired4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropvalidationprizenamerequired4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropvalidationprizenamerequired4(inputs)
	return de_dropvalidationprizenamerequired4(inputs)
});
export { dropvalidationprizenamerequired4 as "dropValidationPrizeNameRequired" }